import { Badge, Group, Stack, Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import type { PlaceholderInfo } from "./api";

// Легенда плейсхолдеров: список из ответа API (ничего не хардкодим).
// Task-id-токены помечены Badge «обязателен» — шаблон обязан содержать
// хотя бы один такой токен.
export function TemplateLegend({
  placeholders,
}: {
  readonly placeholders: readonly PlaceholderInfo[];
}): ReactElement {
  const { t } = useTranslation();
  return (
    <Stack gap="xs">
      <Text fw={600} size="sm">
        {t("branchNameTemplate.legend.title")}
      </Text>
      <Text c="dimmed" size="xs">
        {t("branchNameTemplate.legend.hint")}
      </Text>
      <Stack gap={4}>
        {placeholders.map((placeholder) => (
          <Group key={placeholder.name} gap="xs" wrap="nowrap">
            <Text size="sm" ff="monospace">
              {`{${placeholder.name}}`}
            </Text>
            {placeholder.is_task_id ? (
              <Badge size="xs" color="orange" variant="light">
                {t("branchNameTemplate.legend.required")}
              </Badge>
            ) : null}
          </Group>
        ))}
      </Stack>
    </Stack>
  );
}
